import React, {Component} from 'react';
import {Dimmer, Loader} from 'semantic-ui-react';

export default class FriMenu extends Component {
    render() {
        return (
            <Dimmer inverted active={this.props.active.show}>
                <Loader indeterminate>{this.props.active.message}</Loader>
            </Dimmer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/FriLoading.js